export class FirecatcherEvents {
    public static AWARD_STARTED = Symbol('AWARD_STARTED');
    public static AWARD_FINISHED = Symbol('AWARD_FINISHED');
}